import { OrderItem } from '../api/orders';

export const isServiceOrderItem = (item: OrderItem): boolean => {
  if (!item) {
    return false;
  }

  if (item.productVariant?.isCreatedByWorkshopManagement) {
    return true;
  }

  const typeValue = item.itemType?.toLowerCase?.();
  return typeValue === 'service';
};

export const getOrderItemDisplayName = (item: OrderItem): string => {
  if (item.productVariant?.name) {
    return item.productVariant.name;
  }

  if (item.description) {
    return item.description;
  }

  return 'Service item';
};
